module.exports = __webpack_public_path__ + "static/taco-img-2317dbdac3305d454ab1e2ef3d923de6.jpg";